import { Injectable } from "@angular/core";
import { PublicHttpClientService } from "./http-client.service";

interface publicDocumentParams {
  content: string;
  category: string;
  original_filename: string;
  format: string;
}

@Injectable({
  providedIn: "root",
})
export class FoldersService {
  constructor(private http: PublicHttpClientService) {}

  public saveWebsitePublicDocument(publicDocument: publicDocumentParams) {
    return this.http.post("/api/public/folders/website/public_document", publicDocument);
  }
}
